import { atom } from 'jotai';

import { ExamCategory } from 'src/types/exam';

export const examCategory = atom<ExamCategory[]>();

export const examIntro = atom<any>();

export const actions = atom<any>();

export const currentQuestionSolvedStatusExam = atom<any>();
